/* Puschies (1:1 aus CallMePuppy): Land- und Sprachauswahl + einmaliger Sprach-Hinweis (Markup: snippets/p-localization.liquid).
   Keine Texte im JS: alles kommt aus dem Liquid-Markup (locales) bzw. per Section Rendering API. */
(function () {
  var modal = document.getElementById('p-loc');
  var form = document.getElementById('p-loc-form');
  if (!modal || !form) return;
  var hint = document.getElementById('p-lhint');
  var KEY = 'p-lang-choice';
  var root = document.documentElement;
  var curCountry = modal.getAttribute('data-country');
  var curLang = modal.getAttribute('data-lang');
  var panel = modal.querySelector('.p-loc__panel');
  var backBtn = modal.querySelector('[data-p-loc-back]');
  var stepCountry = modal.querySelector('[data-step="country"]');
  var stepLang = modal.querySelector('[data-step="language"]');
  var langGrid = modal.querySelector('[data-p-loc-langs]');
  var openEl = null;
  var lastFocus = null;
  var picked = null;

  // Fixed-Overlays direkt ans <body> (nicht in Section-Containern mit transform/overflow stecken lassen)
  [modal, hint].forEach(function (el) { if (el && el.parentElement !== document.body) document.body.appendChild(el); });

  function remember(v) { try { localStorage.setItem(KEY, v); } catch (e) {} }
  function remembered() { try { return localStorage.getItem(KEY); } catch (e) { return 'blocked'; } }

  function focusables(el) {
    return Array.prototype.filter.call(
      el.querySelectorAll('button, [href], input, select, [tabindex]:not([tabindex="-1"])'),
      function (n) { return !n.disabled && n.offsetParent !== null; }
    );
  }

  function open(el, focusTarget) {
    if (openEl && openEl !== el) close(openEl, true);
    lastFocus = document.activeElement;
    openEl = el;
    el.hidden = false;
    root.classList.add('p-loc-lock');
    requestAnimationFrame(function () { requestAnimationFrame(function () { el.classList.add('is-open'); }); });
    var f = focusTarget || focusables(el)[0];
    if (f) f.focus({ preventScroll: true });
  }

  function close(el, keepLock) {
    if (!el || el.hidden) return;
    el.classList.remove('is-open');
    if (openEl === el) openEl = null;
    if (!keepLock) root.classList.remove('p-loc-lock');
    setTimeout(function () { if (!el.classList.contains('is-open')) el.hidden = true; }, 250);
    if (!keepLock && lastFocus && document.contains(lastFocus)) lastFocus.focus({ preventScroll: true });
  }

  function showStep(lang) {
    stepCountry.hidden = lang;
    stepLang.hidden = !lang;
    backBtn.hidden = !lang;
    panel.setAttribute('aria-labelledby', lang ? 'p-loc-t-language' : 'p-loc-t-country');
    panel.scrollTop = 0;
    var cur = (lang ? stepLang : stepCountry).querySelector('.p-loc__opt[aria-current="true"]:not([hidden])');
    var first = cur || (lang ? stepLang : stepCountry).querySelector('.p-loc__opt:not([hidden])');
    if (first) first.focus({ preventScroll: true });
  }

  function submit(country, lang) {
    remember(lang || curLang);
    if (country === curCountry && (!lang || lang.toLowerCase() === curLang)) { close(openEl); return; }
    form.elements.country_code.value = country;
    if (lang) form.elements.language_code.value = lang;
    form.submit();
  }

  function pickCountry(btn) {
    picked = btn.getAttribute('data-p-loc-country');
    var langs = (btn.getAttribute('data-langs') || '').split(',').filter(Boolean);
    if (langs.length < 2) {
      var only = langs[0] && langGrid.querySelector('[data-p-loc-lang="' + langs[0] + '"]');
      submit(picked, only ? only.getAttribute('data-code') : null);
      return;
    }
    // Sprachen des Landes in Zuordnungs-Reihenfolge zeigen, übrige ausblenden
    Array.prototype.forEach.call(langGrid.children, function (b) { b.hidden = true; b.removeAttribute('aria-current'); });
    langs.forEach(function (code) {
      var b = langGrid.querySelector('[data-p-loc-lang="' + code + '"]');
      if (!b) return;
      b.hidden = false;
      if (code === curLang) b.setAttribute('aria-current', 'true');
      langGrid.appendChild(b);
    });
    showStep(true);
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;
    var opener = t.closest('[data-p-loc-open]');
    if (opener) {
      e.preventDefault();
      showStep(false);
      open(modal, stepCountry.querySelector('.p-loc__opt[aria-current="true"]'));
      return;
    }
    if (!openEl) return;
    if (t.closest('[data-p-loc-close]')) { close(modal); return; }
    if (t.closest('[data-p-loc-back]')) { showStep(false); return; }
    var c = t.closest('[data-p-loc-country]');
    if (c) { pickCountry(c); return; }
    var l = t.closest('[data-p-loc-lang]');
    if (l) { submit(picked || curCountry, l.getAttribute('data-code')); return; }
    if (t.closest('[data-p-lhint-stay]')) { remember(curLang); close(hint); return; }
    if (t.closest('[data-p-lhint-switch]')) { submit(curCountry, hint.getAttribute('data-code')); }
  });

  // Capture-Phase: ESC schließt nur diesen Dialog, nicht zusätzlich das Menü darunter
  window.addEventListener('keydown', function (e) {
    if (!openEl) return;
    if (e.key === 'Escape') {
      e.stopPropagation();
      if (openEl === hint) remember(curLang);
      close(openEl);
      return;
    }
    if (e.key !== 'Tab') return;
    // Fokus im offenen Dialog halten
    var list = focusables(openEl);
    if (!list.length) return;
    var first = list[0], last = list[list.length - 1];
    if (e.shiftKey && (document.activeElement === first || !openEl.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && (document.activeElement === last || !openEl.contains(document.activeElement))) { e.preventDefault(); first.focus(); }
  }, true);

  // Sprach-Hinweis: nur wenn Liquid ihn ausgegeben hat und noch nie beantwortet
  if (!hint || remembered()) return;
  function showHint() {
    if (remembered() || openEl) return;
    var shown = false;
    var go = function () { if (!shown && !openEl) { shown = true; open(hint); } };
    // Überschrift zusätzlich in der Landessprache: dieselbe locales-Übersetzung, von Shopify in dieser Sprache gerendert
    var base = (hint.getAttribute('data-root') || '/').replace(/\/?$/, '/');
    var foreign = hint.querySelector('[data-p-lhint-foreign]');
    var local = hint.querySelector('.p-lhint__local');
    fetch(base + '?sections=p-lang-hint', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        var html = j && j['p-lang-hint'];
        if (!html) return;
        var tpl = document.createElement('template');
        tpl.innerHTML = html;
        var el = tpl.content.querySelector('[data-p-lhint-text]');
        var txt = el ? el.textContent.trim() : '';
        if (txt && txt !== local.textContent.trim()) { foreign.textContent = txt; foreign.hidden = false; }
      })
      .catch(function () {})
      .then(go);
    setTimeout(go, 2500);
  }
  var later = function () { setTimeout(showHint, 1200); };
  if (document.readyState === 'complete') later(); else window.addEventListener('load', later);
})();
